import React, { useState } from 'react';
import './CabOptions.css';

const fmt = (n) => {
    const v = parseFloat(n);
    if (isNaN(v)) return '';
    return v.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
};

// Default pick: sedan when offered, else the cheapest option
export const defaultCabCategory = (cab) => {
    const opts = cab?.options || [];
    if (opts.some(o => o.category === 'sedan')) return 'sedan';
    const cheapest = [...opts].sort((a, b) => (a.total_price || 0) - (b.total_price || 0))[0];
    return cheapest?.category || null;
};

export const selectedCabPrice = (cab, selected) => {
    const opt = (cab?.options || []).find(o => o.category === selected);
    return opt?.total_price || 0;
};

/**
 * Horizontal scrollable car-type pills + Book Cab button.
 * Rendered inside commute/layover cards. Mirrors the train seat-class
 * grid interaction: one pill preselected, selected price surfaces to the
 * card header via the parent (selectedCabPrice helper).
 */
const CabOptions = ({ cab, selected, onSelect }) => {
    const [comingSoon, setComingSoon] = useState(false);
    if (!cab || !Array.isArray(cab.options) || cab.options.length === 0) return null;

    const selectedOpt = cab.options.find(o => o.category === selected) || cab.options[0];

    const handleBook = (e) => {
        e.stopPropagation();
        if (comingSoon) return;
        setComingSoon(true);
        setTimeout(() => setComingSoon(false), 2200);
    };

    // "Sedan (4 seats, 3 bags)" → name: "Sedan", sub: "4 seats, 3 bags"
    const splitUi = (opt) => {
        const m = /^([^(]+)\(([^)]+)\)/.exec(opt.category_ui || '');
        if (m) return { name: m[1].trim(), sub: m[2].trim() };
        return { name: opt.category_ui || opt.category, sub: `${opt.max_pax} seats, ${opt.max_bags} bags` };
    };

    return (
        <div className="cab-options-block" onClick={(e) => e.stopPropagation()}>
            <div className="cab-options-row">
                {cab.options.map((opt) => {
                    const { name, sub } = splitUi(opt);
                    const isActive = opt.category === selectedOpt.category;
                    return (
                        <button
                            key={opt.category}
                            className={`cab-pill ${isActive ? 'active' : ''}`}
                            onClick={(e) => { e.stopPropagation(); onSelect && onSelect(opt.category); }}
                        >
                            <div className="cab-pill-top">
                                <span className="cab-pill-name">{name}</span>
                            </div>
                            <span className="cab-pill-sub">{sub}</span>
                            <span className="cab-pill-price">{fmt(opt.total_price)}</span>
                        </button>
                    );
                })}
            </div>
            <div className="cab-options-footer">
                <span className="cab-km-note">
                    {cab.distance_kms ? `${cab.distance_kms} km included` : ''}
                    {selectedOpt.extra_km_rate ? `${cab.distance_kms ? ' · ' : ''}₹${selectedOpt.extra_km_rate}/km after` : ''}
                </span>
                <button
                    className={`cab-book-btn ${comingSoon ? 'soon' : ''}`}
                    onClick={handleBook}
                >
                    {comingSoon ? 'Coming soon 🚧' : 'Book Cab'}
                </button>
            </div>
        </div>
    );
};

export default CabOptions;
